import FullCalendar from "@fullcalendar/react"
import React, { useEffect, useRef, useState } from "react"
import allLocales from '@fullcalendar/core/locales-all'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import { EventContentArg } from '@fullcalendar/core'
import interactionPlugin from "@fullcalendar/interaction"
import Caret from '../img/caret.svg'
import CalendarMorePopup from "./CalendarMorePopup"
import { useNavigate } from 'react-router-dom'
import useEstimateStore from "../stores/estimate"

export const CalendarContainer = (props:any) => {
    const {calendarRef, events, activeItem} = props
    const { setEstimate, estimateList} = useEstimateStore()
    const navigate = useNavigate()

    const MONTH_CALGRID = 0
    const WEEK_CALGRID = 1
    const DAY_CALGRID = 2
    const [selectedGrid, setSelectedGrid] = useState(MONTH_CALGRID)
    
    const gridList = ["dayGridMonth", "timeGridWeek", "timeGridDay"]
    const [coordinates, setCoordinates] = useState({ top: 0, left: 0 })
    const [calData, setCalData] = useState([])
    const [curTime, setCurTime] = useState(new Date())
    const [isPopupOpen, setIsPopupOpen] = useState(false)

    // update events
    useEffect(() => {
        const calendarApi = calendarRef.current?.getApi()
        if (calendarApi) {
            calendarApi.removeAllEvents()
            calendarApi.addEventSource(events)
        }
    }, [events])

    useEffect(() => {
        const calendarApi = calendarRef.current?.getApi()
        const resizeObserver = new ResizeObserver(() => {
          if (calendarApi) {
            calendarApi.updateSize()
          }
        })
    
        if (calendarApi) {
          resizeObserver.observe(document.querySelector('.calendar_box') as Element)
        }
    
        return () => {
          resizeObserver.disconnect()
        }
      }, [activeItem])

    const renderEventContent=(eventInfo:EventContentArg)=> {
        // 00:00
        const startHour = eventInfo.event.start?.getHours().toString().padStart(2,'0') + ":" + 
            eventInfo.event.start?.getMinutes().toString().padStart(2, '0')

        const handleEventClick = (e:any) => {
            e.stopPropagation()
            const esti = estimateList.find((item:any)=>item.id === eventInfo.event.extendedProps?.estID)
            setEstimate(esti ?? null)
            navigate('/note')
        }
        
        return (
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%"}} onClick={handleEventClick}>
                <div style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: "0 3px"}}>
                    <span className="circle" style={{
                        display: 'inline-block',
                        marginRight: '7px',
                        width: '11px',
                        height: '11px',
                        borderRadius: '8px',
                        background: '#51D7DF'
                    }}/>
                    {eventInfo.event.title}
                </div>
                <div style={{ whiteSpace: "nowrap", margin: "0 3px"}}>
                    {startHour}
                </div>
            </div>

        )
    }
    

    // 팝업창 위치 설정
    const setCoord = (clientX:number, clientY:number) => {
        const sWidth = window.innerWidth
        const sHeight = window.innerHeight
        
        const oWidth = popRef.current ? popRef.current.offsetWidth : 0
        const oHeight = popRef.current ? popRef.current.offsetHeight : 0
        
        let divLeft = clientX + 20
        let divTop = clientY + 300
    
        if (divLeft + oWidth > sWidth) divLeft -= oWidth
        if (divTop + oHeight > sHeight) divTop -= oHeight

        if (divLeft < 0) divLeft = 0
        if (divTop < 0) divTop = 0
    
        setCoordinates({ top: divTop, left: divLeft })
    }

    const handleDateClick = (arg:any) => {
        if (!calendarRef.current) return

        const calendarApi = calendarRef.current.getApi()
        const events = calendarApi.getEvents()
        const dateClicked = arg.date // 클릭된 날짜
        
        // 클릭된 날짜에 해당하는 이벤트들을 필터링
        const eventsOnDate = events.filter((event:any) => {
            // dateClicked - datceClicked + 1day
            const minDate = new Date(dateClicked)
            const maxDate = new Date(dateClicked).setDate(dateClicked.getDate() + 1)
            const eventDate = event.start

            return (eventDate >= minDate && eventDate <= maxDate)
        })

        // 선택적으로, 이벤트 데이터를 다른 방식으로 활용할 수 있습니다 (예: 팝업 또는 모달 표시).
        isPopupOpen ? setIsPopupOpen(false) : setIsPopupOpen(true)
        setCurTime(dateClicked)
        setCoord(arg.jsEvent.clientX, arg.jsEvent.clientY)
        setCalData(eventsOnDate)
    }
    

    const handleMoreLinkClick = (clickInfo:any) => {
        clickInfo.jsEvent.preventDefault()
        handleDateClick(clickInfo)
        return gridList[selectedGrid]
    }

    const popRef = useRef<HTMLDivElement>(null)
    const [calendarTitle, setCalendarTitle] = useState<string>("")

    useEffect(() => { setCalendarTitleHandler() }, [calendarRef])
    const setCalendarTitleHandler = () => {
        if(!calendarRef.current) return
        setCalendarTitle(calendarRef.current?.getApi().view.title)
    }

    const prevMonth = () => {
        if(!calendarRef.current) return
        calendarRef.current?.getApi().prev()
        setCalendarTitleHandler()
    }

    const nextMonth = () => {
        if(!calendarRef.current) return
        calendarRef.current?.getApi().next()
        setCalendarTitleHandler()
    }

    return (
        <div className="calendar_box">
        {isPopupOpen && <CalendarMorePopup popRef={popRef}
                           coordinates={coordinates} data={calData} curTime={curTime}/>}
        <h2>일정</h2>
            <div id="calendar-container">
                <div style={{ display: "flex", marginBottom: "10px"}}>
                    <button onClick={prevMonth}><img src={Caret} style={{transform: "rotate(180deg)"}}alt={"prev"}/></button>
                        <div style={{
                            width: "190px",
                            display: "inline-block",
                            textAlign: "center",
                            fontSize: "24px",
                            fontWeight: "600",
                            paddingLeft: "30px",
                            paddingRight: "30px",
                            whiteSpace: "nowrap"
                        }}>{calendarTitle}</div>
                    <button onClick={nextMonth}><img src={Caret} alt={"next"}/></button>
                </div>
                <FullCalendar
                    ref={calendarRef}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    height={"580px"}
                    headerToolbar={false}
                    editable={false}
                    selectable={false}
                    navLinks={false}
                    dayMaxEvents={true}                        
                    locales={allLocales}
                    locale="ko"
                    slotMinTime="04:00"
                    slotMaxTime="22:00"
                    events={events}
                    eventContent={renderEventContent}
                    dateClick={handleDateClick}
                    moreLinkClick={handleMoreLinkClick}
                    customButtons= {
                        {
                            gridSelectButton: {
                                text: `${selectedGrid}`,
                                click: function() {
                                    // 'dayGridMonth,timeGridWeek,timeGridDay'
                                    let index = MONTH_CALGRID

                                    if(selectedGrid === MONTH_CALGRID) {
                                        index = WEEK_CALGRID
                                        setSelectedGrid(WEEK_CALGRID)
                                    }
                                    else if(selectedGrid === WEEK_CALGRID) {
                                        index = DAY_CALGRID
                                        setSelectedGrid(DAY_CALGRID)
                                    }
                                    else if(selectedGrid === DAY_CALGRID) {
                                        index = MONTH_CALGRID
                                        setSelectedGrid(MONTH_CALGRID)
                                    }

                                    if(calendarRef) {
                                        calendarRef.current?.getApi().changeView(gridList[index])
                                    }
                                }
                            }
                        }
                    }
                    />
            </div>
        </div>
    )
}